import { motion, AnimatePresence } from 'framer-motion';
import { ReactNode } from 'react';

export const AnimatedCollapse = ({
  collapse,
  children,
}: {
  collapse: boolean;
  children: ReactNode;
}) => {
  return (
    <AnimatePresence>
      {collapse ? (
        <motion.div
          initial={{ opacity: 0, height: 0 }}
          animate={{ opacity: 1, height: 'auto' }}
          exit={{ opacity: 0, height: 0 }}
          transition={{ duration: 0.3 }}
          className="w-full"
        >
          {children}
        </motion.div>
      ) : null}
    </AnimatePresence>
  );
};
